<template>
  <div>
    <div class="d-flex mb-3">
      <h1 class="h4 primary--text">
        {{ $t('views.shipment_notice_creation.shipment_notice_creation') }}
      </h1>
      <div class="ml-auto d-flex">
        <router-link
          :to="backUrl"
          class="shipment-notice__back-link my-auto"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
          >
            <path
              d="M9,4l.881.881L6.394,8.375H14v1.25H6.394l3.487,3.494L9,14,4,9Z"
              transform="translate(-4 -4)"
            />
          </svg>
          {{ $t('views.shipment_notice_creation.back_to_list') }}
        </router-link>
      </div>
    </div>
    <app-loader v-if="loading" />
    <shipment-notice-form
      v-else
      :initial-asn="asn"
      :saving="saving"
      :is-new="isNew"
      @save="create"
    />
    <shipment-notice-errors-modal
      v-model="isErrorsModalShown"
      :error-list="errorsModalList"
      :title="$t('views.shipment_notice_edit.validation_errors')"
    />
  </div>
</template>

<script>
import ShipmentNoticeForm from '@/components/asn/ShipmentNoticeForm.vue';
import ShipmentNoticeErrorsModal from '@/components/asn/ShipmentNoticeErrorsModal.vue';
import AppLoader from '@/components/common/AppLoader.vue';

export default {
  name: 'ShipmentNoticeCreation',

  components: {
    ShipmentNoticeForm,
    ShipmentNoticeErrorsModal,
    AppLoader,
  },

  data() {
    return {
      saving: false,
      loading: false,
      asn: null,
      isNew: true,

      isErrorsModalShown: false,
      errorsModalList: [],
    };
  },

  computed: {
    order() {
      return this.$route.query.order;
    },
    backUrl() {
      if (this.order) {
        return `/aftersales-orders/${this.order}`;
      }

      return '/asn';
    },
  },

  created() {
    if (this.order) {
      this.getAfterSalesOrder();
    }
  },

  methods: {
    async getAfterSalesOrder() {
      this.loading = true;
      try {
        const { data = {} } = await this.$http.get(`/aftersales-orders/${this.order}`);

        const confirmedParts = data.parts.filter((part) => part.isConfirmed);
        this.asn = {
          isAfterSales: true,
          asOrderNumber: data.number,
          asOrderDate: data.date,
          asOrderGuid: data.GUID,
          supplier: { asdb: data.supplier },
          buyer: { asdb: data.shipto },
          estimatedDate: data.estimatedDate,
          details: confirmedParts.map((part) => ({
            detailNumber: part.partNumber,
            quantitySent: part.amount,
            UOM: part.UOM,
          })),
          packing: confirmedParts.map((part) => ({
            detailNumber: part.partNumber,
            quantity: part.amount,
            UOM: part.UOM,
          })),
        };
      } catch (error) {
        this.$router.push(this.backUrl);
      } finally {
        this.loading = false;
      }
    },

    async create(asn) {
      this.saving = true;
      try {
        await this.$http.post('/asn', asn);

        this.$router.push(this.backUrl);
      } catch (error) {
        if (error.translatedErrorList) {
          this.errorsModalList = error.translatedErrorList;
          this.isErrorsModalShown = true;
        } else {
          this.$toast(this.$t('views.shipment_notice_creation.check_field_errors'), {
            title: this.$t('toast.danger'),
            variant: 'danger',
          });
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shipment-notice__back-link {
  text-decoration: none;
  transition: color 0.3s ease-in-out 0s;

  svg {
    fill: #ad7c59;
    margin-right: 5px;
    transition: fill 0.3s ease-in-out 0s;
  }

  &:hover {
    color: var(--margaritas);

    svg {
      fill: var(--margaritas);
    }
  }
}
</style>
